import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2a60735a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap center" }
const _hoisted_2 = { class: "eyebrow teal" }
const _hoisted_3 = { class: "hero-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  class: "rise-word grad",
  style: {"animation-delay":"0.3s"}
}
const _hoisted_6 = { class: "hero-lede" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = {
  href: "#services",
  class: "btn btn-primary"
}
const _hoisted_9 = {
  href: "#ai",
  class: "btn btn-ghost"
}
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = {
  "font-family": "JetBrains Mono",
  "font-size": "12",
  fill: "#9BB4CB"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  x: "20",
  y: "28"
}, "prod · eu-west · v2.14.0", -1))
const _hoisted_13 = {
  x: "980",
  y: "28",
  "text-anchor": "end",
  fill: "#7FD6DC"
}
const _hoisted_14 = {
  "font-family": "Plus Jakarta Sans",
  "font-size": "14",
  "font-weight": "700",
  fill: "#E8F3FF"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "20",
  y: "70",
  width: "150",
  height: "56",
  rx: "14",
  fill: "#142234"
}, null, -1))
const _hoisted_16 = {
  x: "95",
  y: "103",
  "text-anchor": "middle"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "20",
  y: "150",
  width: "150",
  height: "56",
  rx: "14",
  fill: "#142234"
}, null, -1))
const _hoisted_18 = {
  x: "95",
  y: "183",
  "text-anchor": "middle"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "20",
  y: "250",
  width: "150",
  height: "70",
  rx: "14",
  fill: "#0B2733",
  stroke: "#34B1B9"
}, null, -1))
const _hoisted_20 = {
  x: "95",
  y: "281",
  "text-anchor": "middle"
}
const _hoisted_21 = {
  x: "95",
  y: "302",
  "text-anchor": "middle",
  "font-family": "JetBrains Mono",
  "font-size": "11",
  "font-weight": "400",
  fill: "#7FD6DC"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<circle class=\"ping\" cx=\"170\" cy=\"285\" r=\"6\" fill=\"#34B1B9\" data-v-2a60735a></circle><g stroke=\"#34B1B9\" stroke-width=\"1.6\" fill=\"none\" data-v-2a60735a><path class=\"flowline\" d=\"M170 98 C230 98 230 180 290 180\" data-v-2a60735a></path><path class=\"flowline\" d=\"M170 178 H290\" style=\"animation-delay:0.3s;\" data-v-2a60735a></path><path class=\"flowline\" d=\"M170 285 C230 285 230 196 290 196\" style=\"animation-delay:0.6s;\" data-v-2a60735a></path></g><rect class=\"lit\" x=\"290\" y=\"120\" width=\"140\" height=\"140\" rx=\"18\" fill=\"#0B2733\" stroke=\"#34B1B9\" data-v-2a60735a></rect><text x=\"360\" y=\"182\" text-anchor=\"middle\" font-family=\"Plus Jakarta Sans\" font-size=\"15\" font-weight=\"800\" fill=\"#E8F3FF\" data-v-2a60735a> API gateway </text><text x=\"360\" y=\"204\" text-anchor=\"middle\" font-family=\"JetBrains Mono\" font-size=\"11\" fill=\"#9BB4CB\" data-v-2a60735a> auth · limits · versions </text><path class=\"flowline\" d=\"M430 190 H480\" stroke=\"#34B1B9\" stroke-width=\"1.6\" fill=\"none\" style=\"animation-delay:0.9s;\" data-v-2a60735a></path><rect x=\"480\" y=\"60\" width=\"300\" height=\"270\" rx=\"20\" fill=\"none\" stroke=\"rgba(232,243,255,0.2)\" stroke-dasharray=\"4 5\" data-v-2a60735a></rect><text x=\"500\" y=\"86\" font-family=\"JetBrains Mono\" font-size=\"11\" fill=\"#9BB4CB\" data-v-2a60735a> kubernetes · autoscaling </text><g font-family=\"JetBrains Mono\" font-size=\"11\" fill=\"#C9D6E3\" data-v-2a60735a><rect x=\"500\" y=\"104\" width=\"80\" height=\"60\" rx=\"12\" fill=\"#142234\" stroke=\"#34B1B9\" data-v-2a60735a></rect><text x=\"540\" y=\"139\" text-anchor=\"middle\" data-v-2a60735a>orders</text><rect x=\"590\" y=\"104\" width=\"80\" height=\"60\" rx=\"12\" fill=\"#142234\" stroke=\"#34B1B9\" data-v-2a60735a></rect><text x=\"630\" y=\"139\" text-anchor=\"middle\" data-v-2a60735a>billing</text><rect x=\"680\" y=\"104\" width=\"80\" height=\"60\" rx=\"12\" fill=\"#142234\" stroke=\"#34B1B9\" data-v-2a60735a></rect><text x=\"720\" y=\"139\" text-anchor=\"middle\" data-v-2a60735a>catalog</text><rect x=\"500\" y=\"180\" width=\"80\" height=\"60\" rx=\"12\" fill=\"#142234\" stroke=\"#34B1B9\" data-v-2a60735a></rect><text x=\"540\" y=\"215\" text-anchor=\"middle\" data-v-2a60735a>users</text><rect class=\"pod\" x=\"590\" y=\"180\" width=\"80\" height=\"60\" rx=\"12\" fill=\"#0B2733\" stroke=\"#34B1B9\" data-v-2a60735a></rect><text x=\"630\" y=\"215\" text-anchor=\"middle\" fill=\"#7FD6DC\" data-v-2a60735a> +1 </text><rect class=\"pod\" x=\"680\" y=\"180\" width=\"80\" height=\"60\" rx=\"12\" fill=\"#0B2733\" stroke=\"#34B1B9\" style=\"animation-delay:0.4s;\" data-v-2a60735a></rect><text x=\"720\" y=\"215\" text-anchor=\"middle\" fill=\"#7FD6DC\" data-v-2a60735a> +1 </text><rect x=\"500\" y=\"256\" width=\"260\" height=\"54\" rx=\"12\" fill=\"#142234\" data-v-2a60735a></rect><text x=\"630\" y=\"288\" text-anchor=\"middle\" data-v-2a60735a> postgres · queue · object store </text></g><path class=\"flowline\" d=\"M780 196 H820\" stroke=\"#F0B25A\" stroke-width=\"1.6\" fill=\"none\" style=\"animation-delay:1.2s;\" data-v-2a60735a></path><rect x=\"820\" y=\"140\" width=\"160\" height=\"112\" rx=\"16\" fill=\"#1E1A10\" stroke=\"#F0B25A\" data-v-2a60735a></rect>", 11)
const _hoisted_33 = {
  x: "900",
  y: "176",
  "text-anchor": "middle",
  "font-family": "Plus Jakarta Sans",
  "font-size": "14",
  "font-weight": "800",
  fill: "#F0B25A"
}
const _hoisted_34 = {
  x: "900",
  y: "198",
  "text-anchor": "middle",
  "font-family": "JetBrains Mono",
  "font-size": "11",
  fill: "#E8D3B0"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "852",
  y: "212",
  width: "96",
  height: "26",
  rx: "13",
  fill: "#F0B25A"
}, null, -1))
const _hoisted_36 = {
  x: "900",
  y: "229",
  "text-anchor": "middle",
  "font-family": "Plus Jakarta Sans",
  "font-size": "12",
  "font-weight": "800",
  fill: "#1E1A10"
}
const _hoisted_37 = { class: "wrap" }
const _hoisted_38 = { class: "hl" }
const _hoisted_39 = {
  id: "services",
  class: "pillars light"
}
const _hoisted_40 = { class: "wrap" }
const _hoisted_41 = { class: "eyebrow ink" }
const _hoisted_42 = { class: "h2" }
const _hoisted_43 = { class: "teal-ink" }
const _hoisted_44 = { class: "stack" }
const _hoisted_45 = { class: "pillar-num" }
const _hoisted_46 = { class: "pillar-title" }
const _hoisted_47 = { class: "pillar-text" }
const _hoisted_48 = { class: "chips" }
const _hoisted_49 = {
  key: 0,
  class: "visual code",
  "aria-hidden": "true"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "@Post", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "a" }, "@Body", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k" }, "NewOrder", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "c" }, "// 214 tests · 0 failed", -1))
const _hoisted_58 = {
  key: 1,
  class: "visual pods",
  "aria-hidden": "true"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pods-caption" }, "pods 6 → 9 · p95 82 ms · deploy v2.14.0 · zero downtime", -1))
const _hoisted_60 = {
  key: 2,
  class: "visual agent",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "bubble" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tools" }, [
  /*#__PURE__*/_createElementVNode("span", null, "getContract ✓"),
  /*#__PURE__*/_createElementVNode("span", null, "computeRefund ✓")
], -1))
const _hoisted_63 = { class: "waiting" }
const _hoisted_64 = { class: "everything light" }
const _hoisted_65 = { class: "wrap" }
const _hoisted_66 = { class: "h2 h2-sm" }
const _hoisted_67 = { class: "wrap" }
const _hoisted_68 = { class: "eyebrow teal" }
const _hoisted_69 = { class: "h2" }
const _hoisted_70 = { class: "ai-lede" }
const _hoisted_71 = { class: "carousel-head" }
const _hoisted_72 = ["disabled", "aria-label"]
const _hoisted_73 = ["disabled", "aria-label"]
const _hoisted_74 = ["aria-label"]
const _hoisted_75 = ["stroke"]
const _hoisted_76 = ["d"]
const _hoisted_77 = { class: "foundations" }
const _hoisted_78 = { class: "band dark" }
const _hoisted_79 = { class: "wrap" }
const _hoisted_80 = { class: "band-label" }
const _hoisted_81 = { class: "band-title" }
const _hoisted_82 = { class: "grad" }
const _hoisted_83 = { class: "band-text" }
const _hoisted_84 = { class: "window-label" }
const _hoisted_85 = {
  id: "approach",
  class: "approach"
}
const _hoisted_86 = { class: "wrap" }
const _hoisted_87 = { class: "eyebrow ink" }
const _hoisted_88 = { class: "h2 h2-md" }
const _hoisted_89 = { class: "step-num" }
const _hoisted_90 = { class: "who light" }
const _hoisted_91 = { class: "wrap" }
const _hoisted_92 = { class: "h2 h2-md" }
const _hoisted_93 = { class: "cta" }
const _hoisted_94 = { class: "wrap center" }
const _hoisted_95 = { class: "word" }
const _hoisted_96 = { class: "grad" }
const _hoisted_97 = { class: "cta-text" }

import { ref } from "vue";
import ArrowRight from "../components/ArrowRight.vue";
import ConnecteraLogo from "../components/ConnecteraLogo.vue";
import { useLocalePath } from "../composables/useLocalePath";
import {
  gsap,
  useMotion,
  useLoopPause,
  reveal,
  wordHighlight,
  words,
  motionAllowed
} from "../composables/useMotion";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const lp = useLocalePath();

const pillars = ["build", "run", "automate"];
const everything = [
  "app",
  "kubernetes",
  "cloud",
  "gateway",
  "delivery",
  "ai",
  "security",
  "observability"
];
const aiTiles = [
  { key: "act", icon: "M4 12h5M15 12h5M9 8h6v8H9z" },
  { key: "data", icon: "M4 6h16M4 12h16M4 18h10" },
  {
    key: "guard",
    icon: "M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z M9 12l2 2 4-4"
  },
  { key: "measure", icon: "M3 20h18M6 16l4-5 3 3 5-7" }
];
const bandSteps = ["read", "search", "draft", "decide"];
const approach = ["architect", "build", "ship", "run", "handover"];
const who = ["scaleups", "vendors", "teams"];

const root = ref<HTMLElement>();
const hero = ref<HTMLElement>();
const heroText = ref<HTMLElement>();
const heroPanel = ref<HTMLElement>();
const heroSvg = ref<SVGElement>();
const statement = ref<HTMLElement>();
const statementSection = ref<HTMLElement>();
const pillarCards = ref<HTMLElement[]>([]);
const bento = ref<HTMLElement>();
const aiSection = ref<HTMLElement>();
const track = ref<HTMLElement>();
const band = ref<HTMLElement>();
const bandWindow = ref<HTMLElement>();
const rail = ref<HTMLElement>();
const railFill = ref<HTMLElement>();
const steps = ref<HTMLElement>();
const whoGrid = ref<HTMLElement>();
const ctaTitle = ref<HTMLElement>();

useLoopPause(heroSvg);

useMotion(root, ({ desktop }) => {
  // Hero zoom: desktop pins for 120% while the headline lifts and the panel grows; phone just fades it up.
  if (desktop && hero.value && heroText.value && heroPanel.value) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: hero.value,
          start: "top top",
          end: "+=120%",
          scrub: 1,
          pin: true
        }
      })
      .to(heroText.value, { y: -60, opacity: 0, ease: "none" }, 0)
      .fromTo(
        heroPanel.value,
        { scale: 0.86, borderRadius: 40 },
        {
          scale: 1,
          borderRadius: 20,
          y: () => -((heroText.value?.offsetHeight ?? 0) - 40),
          ease: "none"
        },
        0
      );
    // The panel ends higher than it started: pull the next section up over the space it leaves.
    if (statementSection.value) {
      gsap.set(statementSection.value, {
        marginTop: () => -((heroText.value?.offsetHeight ?? 0) - 40),
        position: "relative",
        zIndex: 1
      });
    }
  } else if (heroPanel.value) {
    reveal(heroPanel.value, heroPanel.value, { y: 40, duration: 0.9 });
  }

  if (statement.value) wordHighlight(statement.value);

  // Stacking cards: as the next card slides over, the one underneath scales to .94 and dims.
  pillarCards.value.forEach((card, i) => {
    const next = pillarCards.value[i + 1];
    if (!next) return;
    gsap.fromTo(
      card,
      { scale: 1, filter: "brightness(1)" },
      {
        scale: 0.94,
        filter: "brightness(0.7)",
        ease: "none",
        scrollTrigger: {
          trigger: next,
          start: "top bottom",
          end: `top ${96 + (i + 1) * 20}px`,
          scrub: true
        }
      }
    );
  });

  if (bento.value)
    reveal(bento.value.children, bento.value, {
      y: 24,
      scale: 0.97,
      duration: 0.45,
      ease: "power3.out"
    });

  // Light to dark: the page deepens as the AI section arrives.
  if (aiSection.value) {
    gsap.fromTo(
      aiSection.value,
      { backgroundColor: "#F5F7F9", color: "#0B1726" },
      {
        backgroundColor: "#070D1A",
        color: "#E8F3FF",
        ease: "none",
        scrollTrigger: {
          trigger: aiSection.value,
          start: "top 90%",
          end: "top 40%",
          scrub: true
        }
      }
    );
  }

  if (band.value && bandWindow.value) {
    reveal(bandWindow.value, band.value, { y: 60, scale: 0.9, duration: 0.9 });
    reveal(bandWindow.value.querySelectorAll(".wstep"), band.value, {
      y: 12,
      delay: 0.5,
      stagger: 0.15
    });
  }

  // Approach: the rail fills with the scroll; each step lights as the rail reaches it.
  if (rail.value && railFill.value && steps.value) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: rail.value,
        start: "top 80%",
        end: "top 30%",
        scrub: true
      }
    });
    tl.fromTo(
      railFill.value,
      { scaleX: 0 },
      { scaleX: 1, ease: "none", duration: 1 },
      0
    );
    Array.from(steps.value.children).forEach((li, i) => {
      tl.fromTo(li, { opacity: 0.35 }, { opacity: 1, duration: 0.1 }, i * 0.2);
    });
  }

  if (whoGrid.value)
    reveal(whoGrid.value.children, whoGrid.value, { stagger: 0.08 });

  if (ctaTitle.value)
    reveal(ctaTitle.value.querySelectorAll(".ch, .grad"), ctaTitle.value, {
      y: 40,
      stagger: 0.015,
      duration: 0.7
    });
});

// AI carousel: arrows, trackpad, swipe and mouse drag.
const atStart = ref(true);
const atEnd = ref(false);
function onTrackScroll() {
  const t = track.value;
  if (!t) return;
  atStart.value = t.scrollLeft < 8;
  atEnd.value = t.scrollLeft + t.clientWidth > t.scrollWidth - 8;
}
function slide(dir: number) {
  const t = track.value;
  const tile = t?.querySelector("li") as HTMLElement | null;
  if (!t || !tile) return;
  t.scrollBy({
    left: dir * (tile.offsetWidth + 16),
    behavior: motionAllowed() ? "smooth" : "auto"
  });
}
function dragStart(e: PointerEvent) {
  const t = track.value;
  if (!t || e.pointerType !== "mouse") return;
  const x0 = e.clientX;
  const s0 = t.scrollLeft;
  t.classList.add("dragging");
  const move = (ev: PointerEvent) => (t.scrollLeft = s0 - (ev.clientX - x0));
  const up = () => {
    t.classList.remove("dragging");
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", up);
  };
  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", up);
}

// Who cards: up to 4° of tilt toward the pointer, desktop pointers only.
const canHover = () =>
  motionAllowed() &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches;
function tilt(e: PointerEvent) {
  if (!canHover()) return;
  const el = e.currentTarget as HTMLElement;
  const r = el.getBoundingClientRect();
  const x = (e.clientX - r.left) / r.width - 0.5;
  const y = (e.clientY - r.top) / r.height - 0.5;
  gsap.to(el, {
    rotateY: x * 8,
    rotateX: -y * 8,
    transformPerspective: 800,
    duration: 0.2,
    ease: "power2.out"
  });
}
function untilt(e: PointerEvent) {
  gsap.to(e.currentTarget as HTMLElement, {
    rotateX: 0,
    rotateY: 0,
    duration: 0.3,
    ease: "power2.out"
  });
}
// CTA button: pulled up to 6 px toward the pointer.
function magnet(e: PointerEvent) {
  if (!canHover()) return;
  const el = e.currentTarget as HTMLElement;
  const r = el.getBoundingClientRect();
  const x = ((e.clientX - r.left) / r.width - 0.5) * 12;
  const y = ((e.clientY - r.top) / r.height - 0.5) * 12;
  gsap.to(el, { x, y, duration: 0.2, ease: "power2.out" });
}
function unmagnet(e: PointerEvent) {
  gsap.to(e.currentTarget as HTMLElement, {
    x: 0,
    y: 0,
    duration: 0.3,
    ease: "power2.out"
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "home"
  }, [
    _createElementVNode("section", {
      ref_key: "hero",
      ref: hero,
      class: "hero dark"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "heroText",
          ref: heroText
        }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("home.hero.eyebrow")), 1),
          _createElementVNode("h1", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(words)(_ctx.$t('home.hero.line1')), (w, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'a' + i
              }, [
                _createElementVNode("span", {
                  class: "rise-word",
                  style: _normalizeStyle({ animationDelay: i * 0.07 + 's' })
                }, _toDisplayString(w), 5),
                _createTextVNode(_toDisplayString(" "))
              ], 64))
            }), 128)),
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("home.hero.line2")), 1)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("home.hero.lede")), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("home.hero.cta_primary")), 1),
            _createElementVNode("a", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t("home.hero.cta_secondary")), 1),
              _createVNode(ArrowRight)
            ])
          ])
        ], 512),
        _createElementVNode("figure", {
          ref_key: "heroPanel",
          ref: heroPanel,
          class: "system",
          "aria-label": _ctx.$t('home.hero.panel_label')
        }, [
          (_openBlock(), _createElementBlock("svg", {
            ref_key: "heroSvg",
            ref: heroSvg,
            viewBox: "0 0 1000 380",
            width: "100%",
            "aria-hidden": "true"
          }, [
            _createElementVNode("g", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("text", _hoisted_13, " ● " + _toDisplayString(_ctx.$t("home.hero.status")), 1)
            ]),
            _createElementVNode("g", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("text", _hoisted_16, _toDisplayString(_ctx.$t("home.hero.d_web")), 1),
              _hoisted_17,
              _createElementVNode("text", _hoisted_18, _toDisplayString(_ctx.$t("home.hero.d_partners")), 1),
              _hoisted_19,
              _createElementVNode("text", _hoisted_20, _toDisplayString(_ctx.$t("home.hero.d_agent")), 1),
              _createElementVNode("text", _hoisted_21, _toDisplayString(_ctx.$t("home.hero.d_agent_sub")), 1)
            ]),
            _hoisted_22,
            _createElementVNode("text", _hoisted_33, _toDisplayString(_ctx.$t("home.hero.d_approval")), 1),
            _createElementVNode("text", _hoisted_34, _toDisplayString(_ctx.$t("home.hero.d_refund")), 1),
            _hoisted_35,
            _createElementVNode("text", _hoisted_36, _toDisplayString(_ctx.$t("home.hero.d_approve")), 1)
          ], 512))
        ], 8, _hoisted_10)
      ])
    ], 512),
    _createElementVNode("section", {
      ref_key: "statementSection",
      ref: statementSection,
      class: "statement dark"
    }, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("p", {
          ref_key: "statement",
          ref: statement,
          class: "statement-text"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(words)(_ctx.$t('home.statement')), (w, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(w), 1),
              _createTextVNode(_toDisplayString(" "))
            ], 64))
          }), 128))
        ], 512)
      ])
    ], 512),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("home.pillars.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_42, [
          _createTextVNode(_toDisplayString(_ctx.$t("home.pillars.title_a")) + " ", 1),
          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("home.pillars.title_b")), 1)
        ]),
        _createElementVNode("div", _hoisted_44, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pillars, (p, i) => {
            return _createElementVNode("article", {
              key: p,
              ref_for: true,
              ref_key: "pillarCards",
              ref: pillarCards,
              class: _normalizeClass(['pillar', 'pillar-' + p]),
              style: _normalizeStyle({ top: 96 + i * 20 + 'px' })
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_45, " 0" + _toDisplayString(i + 1) + " · " + _toDisplayString(_ctx.$t(`home.pillars.${p}.tag`)), 1),
                _createElementVNode("h3", _hoisted_46, _toDisplayString(_ctx.$t(`home.pillars.${p}.title`)), 1),
                _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t(`home.pillars.${p}.text`)), 1),
                _createElementVNode("ul", _hoisted_48, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (c) => {
                    return _createElementVNode("li", { key: c }, _toDisplayString(_ctx.$t(`home.pillars.${p}.chips.c${c}`)), 1)
                  }), 64))
                ])
              ]),
              (p === 'build')
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _hoisted_50,
                    _createTextVNode("('orders')"),
                    _hoisted_51,
                    _createTextVNode("create("),
                    _hoisted_52,
                    _createTextVNode("() order: "),
                    _hoisted_53,
                    _createTextVNode(") {"),
                    _hoisted_54,
                    _createTextVNode("  return this.orders.place(order);"),
                    _hoisted_55,
                    _createTextVNode("}"),
                    _hoisted_56,
                    _hoisted_57
                  ]))
                : (p === 'run')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                        return _createElementVNode("span", {
                          key: n,
                          class: _normalizeClass(['podbox', { lit: n === 4 || n > 6 }]),
                          style: _normalizeStyle({ animationDelay: (n % 3) * 0.6 + 's' })
                        }, null, 6)
                      }), 64)),
                      _hoisted_59
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t("home.pillars.automate.v_request")), 1),
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("home.pillars.automate.v_wait")), 1)
                    ]))
            ], 6)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("h2", _hoisted_66, _toDisplayString(_ctx.$t("home.everything.title")), 1),
        _createElementVNode("div", {
          ref_key: "bento",
          ref: bento,
          class: "bento"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(everything, (k) => {
            return _createElementVNode("article", {
              key: k,
              class: _normalizeClass(['tile', { 'tile-dark': k === 'ai' }])
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`home.everything.${k}.title`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`home.everything.${k}.text`)), 1)
            ], 2)
          }), 64))
        ], 512)
      ])
    ]),
    _createElementVNode("section", {
      id: "ai",
      ref_key: "aiSection",
      ref: aiSection,
      class: "ai"
    }, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.$t("home.ai.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_69, _toDisplayString(_ctx.$t("home.ai.title")), 1),
        _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.$t("home.ai.lede")), 1),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("button", {
            type: "button",
            class: "arrow",
            disabled: atStart.value,
            "aria-label": _ctx.$t('home.ai.prev'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (slide(-1)))
          }, [
            _createVNode(ArrowRight, { class: "flip" })
          ], 8, _hoisted_72),
          _createElementVNode("button", {
            type: "button",
            class: "arrow",
            disabled: atEnd.value,
            "aria-label": _ctx.$t('home.ai.next'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (slide(1)))
          }, [
            _createVNode(ArrowRight)
          ], 8, _hoisted_73)
        ]),
        _createElementVNode("ul", {
          ref_key: "track",
          ref: track,
          class: "track",
          "aria-label": _ctx.$t('home.ai.eyebrow'),
          onScrollPassive: onTrackScroll,
          onPointerdown: dragStart
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aiTiles, (t) => {
            return _createElementVNode("li", {
              key: t.key,
              class: _normalizeClass(['ai-tile', { amber: t.key === 'guard' }])
            }, [
              (_openBlock(), _createElementBlock("svg", {
                width: "44",
                height: "44",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: t.key === 'guard' ? '#F0B25A' : '#34B1B9',
                "stroke-width": "1.6",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", {
                  d: t.icon
                }, null, 8, _hoisted_76)
              ], 8, _hoisted_75)),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`home.ai.${t.key}.title`)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t(`home.ai.${t.key}.text`)), 1)
              ])
            ], 2)
          }), 64))
        ], 40, _hoisted_74),
        _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.$t("home.ai.foundations")), 1)
      ])
    ], 512),
    _createElementVNode("section", _hoisted_78, [
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", {
          ref_key: "band",
          ref: band,
          class: "flag"
        }, [
          _createElementVNode("div", null, [
            _createVNode(ConnecteraLogo, { class: "band-logo" }),
            _createElementVNode("p", _hoisted_80, _toDisplayString(_ctx.$t("home.connectera.label")), 1),
            _createElementVNode("h2", _hoisted_81, [
              _createTextVNode(_toDisplayString(_ctx.$t("home.connectera.title_a")) + " ", 1),
              _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.$t("home.connectera.title_b")), 1)
            ]),
            _createElementVNode("p", _hoisted_83, _toDisplayString(_ctx.$t("home.connectera.text")), 1),
            _createVNode(_component_router_link, {
              to: _unref(lp)('/connectera'),
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("home.connectera.cta")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", {
            ref_key: "bandWindow",
            ref: bandWindow,
            class: "window",
            "aria-hidden": "true"
          }, [
            _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.$t("home.connectera.process")), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bandSteps, (s, i) => {
              return _createElementVNode("div", {
                key: s,
                class: _normalizeClass(['wstep', { amber: i === 3 }])
              }, [
                _createElementVNode("span", {
                  class: "wdot",
                  style: _normalizeStyle({
                  background: ['#E8F3FF', '#34B1B9', '#34B1B9', '#F0B25A'][i]
                })
                }, null, 4),
                _createTextVNode(_toDisplayString(_ctx.$t(`home.connectera.steps.${s}`)), 1)
              ], 2)
            }), 64))
          ], 512)
        ], 512)
      ])
    ]),
    _createElementVNode("section", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("p", _hoisted_87, _toDisplayString(_ctx.$t("home.approach.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_88, _toDisplayString(_ctx.$t("home.approach.title")), 1),
        _createElementVNode("div", {
          ref_key: "rail",
          ref: rail,
          class: "rail"
        }, [
          _createElementVNode("span", {
            ref_key: "railFill",
            ref: railFill,
            class: "rail-fill"
          }, null, 512)
        ], 512),
        _createElementVNode("ol", {
          ref_key: "steps",
          ref: steps,
          class: "steps"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(approach, (s, i) => {
            return _createElementVNode("li", { key: s }, [
              _createElementVNode("p", _hoisted_89, "0" + _toDisplayString(i + 1), 1),
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`home.approach.${s}.title`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`home.approach.${s}.text`)), 1)
            ])
          }), 64))
        ], 512)
      ])
    ]),
    _createElementVNode("section", _hoisted_90, [
      _createElementVNode("div", _hoisted_91, [
        _createElementVNode("h2", _hoisted_92, _toDisplayString(_ctx.$t("home.who.title")), 1),
        _createElementVNode("div", {
          ref_key: "whoGrid",
          ref: whoGrid,
          class: "who-grid"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(who, (k) => {
            return _createElementVNode("article", {
              key: k,
              class: "who-card",
              onPointermove: tilt,
              onPointerleave: untilt
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`home.who.${k}.title`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`home.who.${k}.text`)), 1)
            ], 32)
          }), 64))
        ], 512)
      ])
    ]),
    _createElementVNode("section", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("h2", {
          ref_key: "ctaTitle",
          ref: ctaTitle,
          class: "cta-title"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(words)(_ctx.$t('home.cta.title_a')), (w, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: 'w' + i
            }, [
              _createElementVNode("span", _hoisted_95, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w, (ch, j) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: j,
                    class: "ch"
                  }, _toDisplayString(ch), 1))
                }), 128))
              ]),
              _createTextVNode(_toDisplayString(" "))
            ], 64))
          }), 128)),
          _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t("home.cta.title_b")), 1)
        ], 512),
        _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.$t("home.cta.text")), 1),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/contact'),
          class: "btn btn-primary btn-lg magnetic",
          onPointermove: magnet,
          onPointerleave: unmagnet
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("home.cta.button")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ], 512))
}
}

})